// extracted by mini-css-extract-plugin
export var deliveryRow = "_sb-a";
export var fixedHeight = "_sb-4";
export var freightLogo = "_sb-9";
export var fullWidth = "_sb-3";
export var priceColumn = "_sb-5";
export var radioSelected = "_sb-7";
export var radioUnselected = "_sb-6";
export var selectedOption = "_sb-2";
export var selectedOptionContainer = "_sb-1";
export var selection = "_sb-0";
export var tallSkeletonText = "_sb-8";